import { uniqueId } from "lodash";
import PropTypes from "prop-types";

export const TableRow = ({ network, handleClick, noEtrPersonaSelected, etrIssuanceEnabled }) => {
	return (
		<tr className="etr-issuance__table-row" key={uniqueId()}>
			<td className="etr-issuance__table-cell">
				<label className="etr-issuance__margin-default">
					{network.label}
				</label>
			</td>
			<td className="etr-issuance__table-cell etr-issuance__table-cell--status">
				<div className="etr-issuance__divider" />
				<p className="etr-issuance__text-subtitle">
					{network.$selected ? "Included" : "Excluded"}
				</p>
				<label className="switch etr-issuance__margin-default">
					<input
						data-testid={'etrCheckBoxTableRow'}
						disabled={noEtrPersonaSelected || !etrIssuanceEnabled}
						type="checkbox"
						checked={network.$selected}
						onChange={handleClick}
					/>
					<span className="slider round"></span>
				</label>
			</td>
		</tr>
	);
};

TableRow.propTypes = {
	network: PropTypes.object,
	handleClick: PropTypes.func,
	noEtrPersonaSelected: PropTypes.bool,
	etrIssuanceEnabled: PropTypes.bool
};
